import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgComponent(props) {
  return (
    <Svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path fill="#FFF" d="M28.908 12.571a.952.952 0 00-.1-.166 3.146 3.146 0 00-.118-.423.489.489 0 00-.02-.048L25.917 5.6A1 1 0 0025 5H7a1 1 0 00-.917.6l-2.77 6.381a2.841 2.841 0 000 2.083A4.75 4.75 0 006 16.609V27a1 1 0 001 1h18a1 1 0 001-1V16.609a4.749 4.749 0 002.687-2.543 2.614 2.614 0 00.163-.655 1.057 1.057 0 00.058-.84zM13 26v-6h2v6zm4 0v-6h2v6zm7 0h-3v-7a1 1 0 00-1-1h-8a1 1 0 00-1 1v7H8v-9a5.2 5.2 0 004-1.8 5.339 5.339 0 008 0 5.2 5.2 0 004 1.8zm2.837-12.7A3.015 3.015 0 0124 15a2.788 2.788 0 01-3-2.5 1 1 0 00-2 0 2.788 2.788 0 01-3 2.5 2.788 2.788 0 01-3-2.5 1 1 0 00-2 0A2.788 2.788 0 018 15a3.016 3.016 0 01-2.838-1.7.836.836 0 010-.571L7.656 7h16.688l2.477 5.7a.858.858 0 01.016.6z" />
    </Svg>
  )
}

export default SvgComponent
